import { render } from "./StatusModal.vue?vue&type=template&id=5e6f4ced"
import script from "./StatusModal.vue?vue&type=script&lang=js"
export * from "./StatusModal.vue?vue&type=script&lang=js"
script.render = render

export default script